module.exports = __webpack_public_path__ + "static/media/icon-more-grey.064587e8.svg";